import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, XIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function CostSection() {
  return <section className="bg-field py-16 sm:py-20" aria-labelledby="cost-title" data-id="element-58" data-mp="4l7ye10or1jy">
      <div className="mx-auto max-w-4xl px-4" data-id="element-59" data-mp="4j52j0cuqe7b">
        <div className="text-center" data-id="element-60" data-mp="3vsapksgix7u6">
          <AlertTriangleIcon className="mx-auto h-9 w-9 text-gold" aria-hidden="true" data-id="element-61" data-mp="3vr94dv5sn4yq" />
          <h2 id="cost-title" className="mt-4 text-3xl font-extrabold text-cream sm:text-4xl" data-id="element-62" data-mp="3qtzg4iu54zch">El costo de no tenerlo</h2>
          <p className="mt-3 text-field-light" data-id="element-63" data-mp="3msxc7opa3z46">Lo que realmente perdés cada ciclo lectivo sin el Megapack</p>
        </div>

        <div className="mt-10 space-y-2" data-id="element-64" data-mp="3cswrbybrhaxv">
          {costs.map(([without, loss], index) => <motion.div key={without} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.03,
          ease: [0.23, 1, 0.32, 1]
        }} className="grid gap-2 rounded-lg border-l-4 border-earth bg-field-deep/60 p-4 sm:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] sm:gap-6" data-id="element-65" data-mp="3cuztfgq6uuiy" data-mpi={index}>
              <p className="flex items-start gap-2 text-sm font-bold text-cream" data-id="element-66" data-mp="fap44qetnjis">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-300" aria-hidden="true" data-id="element-67" data-mp="k7p20e1ipfyt" />
                {without}
              </p>
              <p className="text-sm leading-relaxed text-field-light" data-id="element-68" data-mp="17yup9e9sfaj5">{loss}</p>
            </motion.div>)}
        </div>

        <blockquote className="mt-10 rounded-xl border border-field-soft bg-field-deep/60 p-6 text-center text-sm font-semibold leading-relaxed text-cream sm:p-8" data-id="element-69" data-mp="1cyyxyi4gf0yt">
          “La próxima vez que un alumno pregunte para qué sirve estudiar Yacimientos de Hidrocarburos, podés mostrarle que
          Argentina tiene cuencas petroleras específicas, que existen profesionales dedicados a la exploración y
          caracterización, que los descubrimientos requieren conocimiento profundo de geología, que cada formación
          geológica cuenta una historia de millones de años, y que ser un especialista en yacimientos es contribuir al
          desarrollo energético del país. O podés seguir explicando sin ese contexto.”
        </blockquote>
      </div>
    </section>;
}